<h2 mat-dialog-title>{{ guideTitle }}</h2>

<mat-dialog-content class="guide-dialog">
    <div [innerHTML]="htmlContent"></div>
</mat-dialog-content>

<mat-dialog-actions>
    <button mat-raised-button appPreventDoubleClick (throttledClick)="close()">Close</button>
</mat-dialog-actions>
